/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { IconButton, SelectChangeEvent } from "@mui/material";

import { useNavigate } from "react-router-dom";

import AddCharges from "../../Modals/addChargesModal";
import IosSwitchMain from "../../components/iosSwitchMain";
import {
  useChangeSubscriptionStatusMutation,
  useLazyDeleteSubscriptionQuery,
} from "../../service/subscription";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { formatDubaiDateTime } from "../../utils/dateTime";

type OfferTableProps = {
  data: any;
  getSubscriptionApi: () => void;
  hasFetched: boolean;
};

const SubscriptionTable = ({
  data,
  getSubscriptionApi,
  hasFetched,
}: OfferTableProps) => {
  const navigate = useNavigate();
  const [changeStatus] = useChangeSubscriptionStatusMutation();
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const [deleteApi] = useLazyDeleteSubscriptionQuery();
  const [page, setPage] = useState(1);
  const [selectedId, setSelectedId] = useState("");
  const [openDelete, setOpenDelete] = useState(false);

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };
  const [Employee, setEmployee] = React.useState("0");
  const handleChange1 = (event: SelectChangeEvent) => {
    setEmployee(event.target.value as string);
  };
  const [Status, setStatus] = React.useState("0");
  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const changeSubscriptionStatusApi = async (id: string) => {
    try {
      const response = await changeStatus({
        id,
      }).unwrap();
      if (response.status === 200) {
        getSubscriptionApi();
        showToast(response?.message);
      } else {
        showError(response?.message);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteApi({
        id,
      }).unwrap();
      if (response.status === 200) {
        getSubscriptionApi();
        showToast(response?.message);
      } else {
        showError(response?.message);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <div className="table_container">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Description</th>
              <th>Type</th>
              <th>Price</th>

              <th>Created At</th>
              <th>Status</th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.length ? (
              data?.map((row: any, i: any) => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td>{(page - 1) * 10 + i + 1}</td>
                    <td
                      className="cursor_p max_c2"
                      onClick={() =>
                        navigate("/manage-subscription/view", {
                          state: { data: row },
                        })
                      }
                    >
                      {" "}
                      <p> {row?.memberShipType || "-"}</p>
                    </td>
                    <td className="max_c2">
                      {" "}
                      <p> {row?.description || "-"}</p>{" "}
                    </td>
                    <td>
                      {row?.memberShipPlan === "SemiAnnually"
                        ? "Semi Annually"
                        : row?.memberShipPlan}
                    </td>

                    <td>{row?.price || "-"}</td>
                    <td>
                      {row?.createAt ? formatDubaiDateTime(row?.createAt) : ""}
                    </td>
                    <td>
                      <IosSwitchMain
                        checked={row?.isActive}
                        onChange={() => changeSubscriptionStatusApi(row?.id)}
                      />
                    </td>

                    <td>
                      <div className="table_actions v2">
                        <IconButton
                          className="toggle_btn text_btn"
                          onClick={() => {
                            navigate(`/manage-subscription/edit/${row?.id}`);
                            toggleExpand(row?.id);
                          }}
                        >
                          <img src="/static/images/edit_icon.svg" alt="user" />
                        </IconButton>
                        <IconButton
                          className="toggle_btn text_btn"
                          onClick={() => {
                            setOpenDelete(true);
                            setSelectedId(row?.id);
                            toggleExpand(row.id);
                          }}
                        >
                          <img
                            src="/static/images/delete_icon.svg"
                            alt="user"
                          />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            ) : hasFetched ? (
              <tr>
                <td
                  colSpan={8}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Data Found
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      <AddCharges open={open} onClose={handleCloseModal} setOpen={setOpen} />
      <ConfirmationModal
        text={"Are you sure to delete this Subscription?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => {
          handleDelete(selectedId);
        }}
      />
    </>
  );
};

export default SubscriptionTable;
